import { Box, ColorOptions, Spacer, Text } from '@jfs/ui-new'
import { useFocusEffect, useNavigation } from '@react-navigation/native'
import * as React from 'react'
import { useCallback, useEffect, useRef, useState } from 'react'
import { ExpandAddView } from '../../components/ExpandAddView'
import { ListNew } from '../../components/ListNew'
import { useLazyApiData, useStores } from '../../data/store'
import { isAccessible } from '../../utils'
import AddUpdateUser from '../AddUpdateUser'
import { DownloadListUsers } from './DownloadListUsers'

const Users = () => {
  const [isLoading, setLoading] = useState(true)
  const [isExpand, setIsExpand] = useState(false)
  const { getAllUsers, accessConfig, config, exportFileAsync } = useStores((store) => ({
    getAllUsers: store.userManagement.fetchAllUsers,
    config: store.user.accessConfig,
    accessConfig: store.user.getAccessConfig(['access_management', 'user']),
    exportFileAsync: store.exportFileAsync,
  }))

  const [getAllUsersApi, { state, data: apiData }] = useLazyApiData(getAllUsers)
  const [lazyExportFileAsync, exportFileAsyncHandler] = useLazyApiData(exportFileAsync)

  const searchFormRef = React.useRef(null)
  const abortControllerRef = useRef<AbortController>()
  const getAbortController = () => {
    abortControllerRef.current = new AbortController()
    return abortControllerRef.current
  }

  useFocusEffect(
    React.useCallback(() => {
      if (isAccessible(accessConfig, 'fetch')) {
        setLoading(true)
        getAllUsersApi(searchFormRef?.current?.getValues() ?? {}, { page: 1, size: 10 })
      }
      // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [getAllUsersApi, config]),
  )

  const navigation = useNavigation()
  useEffect(() => {
    if (state === 'fulfilled' || state === 'rejected') {
      setLoading(false)
    }
  }, [state])

  const keyExtractor = (item: any): string => {
    return item.id
  }

  const headTitles = [
    { ID: 'ID' },
    { name: 'Username' },
    { type: 'Type' },
    { group: 'Group' },
    { lastLogin: 'Last login time' },
    { createdBy: 'Created By' },
    { createdDate: 'Creation Date' },
    { status: 'Status' },
  ]

  const fetchDataFromServer = useCallback(
    (data, paginationInfo) => {
      getAllUsersApi(data, paginationInfo)
    },
    [getAllUsersApi],
  )

  console.log('htag', apiData?.content)

  const getList = () => {
    const handleOnPress = (item: any) => {
      navigation.navigate('userDetails', { id: item.ID })
    }

    const exportFile = () => {
      lazyExportFileAsync(searchFormRef?.current?.getValues() ?? {}, 'USER_LIST', '', getAbortController)
    }

    return (
      <Box>
        <Spacer direction="vertical" size={16} />
        <ListNew
          searchFormRef={searchFormRef}
          searchData={SEARCH_FILTERS as any}
          data={apiData?.content}
          updatedPaginationInfo={{
            ...(apiData?.pageNo !== undefined && { page: apiData?.pageNo }),
            ...(apiData?.totalElements !== undefined && {
              total: apiData?.totalElements,
            }),
          }}
          isSearchButtonLoading={state === ('pending' as any)}
          apiHandler={{ state, data: apiData }}
          fetchDataFromServer={fetchDataFromServer}
          keyExtractor={keyExtractor}
          headTitle={headTitles}
          sizeConfig={[0.8, 1.5, 1, 1, 1, 0.8, 1, 1]}
          cellTextStyle={{ fontSize: 12, fontFamily: 'jiotype-medium' }}
          headerTextStyle={{ fontSize: 12, fontFamily: 'jioType-bold', textTransform: 'capitalize' }}
          listTitle="Users"
          onRowItemClick={handleOnPress}
          hrefPath={'userDetails'}
          exportFile={exportFile}
          dbCollumnMapper={{
            name: 'username',
            lastLogin: 'LAST_USED',
            createdBy: 'CREATED_BY',
            status: 'IS_ACTIVE',
            createdDate: 'CREATED_DATE',
          }}
          isExportButtonLoading={exportFileAsyncHandler.state === 'pending'}
        />
      </Box>
    )
  }

  const onUpdate = () => {
    getAllUsersApi(searchFormRef?.current?.getValues() ?? {}, { page: 1, size: 10 })
    setIsExpand(false)
  }

  const onPress = useCallback(() => {
    DownloadListUsers(apiData?.content)
  }, [])

  return (
    <Box flex={1}>
      <Box flexDirection={'row'} justify={'space-between'}>
        <Text title={'Add/View Users'} fontSize={28} fontWeight={'600'} color={'#5a5c69' as ColorOptions} />
      </Box>
      <Spacer direction="vertical" size={24} />
      {isAccessible(accessConfig, 'create_user') && (
        <ExpandAddView
          children={<AddUpdateUser onUpdate={onUpdate} />}
          title={'Add New User'}
          isExpand={isExpand}
          setIsExpand={setIsExpand}
        />
      )}
      {isAccessible(accessConfig, 'fetch') && getList()}
    </Box>
  )
}

export default Users

const SEARCH_FILTERS = [
  [
    { key: 'id', type: 'string', placeHolder: 'ID' },
    { key: 'username', type: 'string', placeHolder: 'User Name' },
    { key: 'type', type: 'string', placeHolder: 'Type' },
    {
      key: 'lastLoginTime',
      type: 'date',
      placeHolder: 'Select Last Login Date',
    },
  ],
  [
    { key: 'createdBy', type: 'string', placeHolder: 'Created By' },
    {
      key: 'createdDate',
      type: 'date',
      placeHolder: 'Select Created Date',
    },
    {
      key: 'isActive',
      type: 'dropdown',
      placeHolder: 'IS Active',
      data: [
        { id: 1, value: 'Active' },
        { id: 2, value: 'InActive' },
      ],
    },
  ],
]
